module.exports = __webpack_public_path__ + "static/media/mama-burger-combo-fr.0f7815bd.jpg";